import { render, staticRenderFns } from "./MiDialog.vue?vue&type=template&id=2c5375ba&scoped=true"
import script from "@/components/mi-dialog/MiDialog.ts?vue&type=script&lang=ts&external"
export * from "@/components/mi-dialog/MiDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/mi-dialog/mi-dialog.scss?vue&type=style&index=0&id=2c5375ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5375ba",
  null
  
)

export default component.exports